import {Workbox} from 'workbox-window';

if ('serviceWorker' in navigator) {
    const wb = new Workbox('/service-worker.js');
    wb.register();
}

require('./analytics');
require('./darkmode');
require('./loadusersettings');
require('./settings');
require('./phpsettings');
require('./select2');
require('./jquery.resizeable');

require('./fontawesome');

require('ace/ace-builds/src-noconflict/ace');
require('ace/ace-builds/src-noconflict/mode-php');
require('ace/ace-builds/src-noconflict/snippets/php');
require('ace/ace-builds/src-noconflict/ext-language_tools');
require('ace/ace-builds/src-noconflict/ext-beautify');

require('./bootstrap');









